<template>
    <div class="configura-campos">
        <div class="novos-campos">
            <!-- <Container drag-handle-selector=".column-drag-handle" :drag-class="'.drop-ghost'" > -->
            <!-- <Draggable v-for="(c, i) in formPerguntaList" :key="i">
                <Campos />
            </Draggable> -->
            <!-- :options="{handle: '.column-drag-handle'}" -->

            <!-- <v-draggable :list="formPerguntaList" handle=".p-handle"> -->
            <template v-for="(formPergunta, i) in formPerguntaList">
                <Campos ref="campo"  
                    v-if="formPergunta.datahoradel == null || formPergunta.datahoradel == undefined"
                    :formPergunta="formPergunta" 
                    :index="i"
                    :expandir="!formPergunta.id" 
                    :copiar-pergunta="copiarPergunta" 
                    :contexto="contexto"
                    :isUpdate="isUpdate"
                    :permissao="permissao"
                    @isLoading="setLoading" 
                    @carregarDados="reload"
                    @isChanged="$emit('isChanged', $event)"
                />
            </template>
            <!-- </v-draggable> -->
            <!-- </Container> -->
        </div>
        <button type="button" class="btn add-campos" @click="addCampo()">
            <p>
                <svg class="svg-icons">
                    <use
                        :xlink:href="require('@/assets/img/icons/shape-plus.svg') + '#layer'"
                    ></use>
                </svg>
                {{ $t('adicionar-novo-campo') }}
            </p>
        </button>
    </div>
</template>

<script>
import Campos from "@/components/promotor/formulario/abas/Campo.vue";
import FormPerguntaService from "@/services/FormPerguntaService.js";

export default {
    components: {
        Campos
    },
    props: {
        formPerguntaList: {
            type: Array,
            default: () => []
        },
        index: {
            type: Number,
            default: 0
        },
        contexto: {
            type: String,
            default: '',
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        permissao: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            // Formulario.vue
            formulario: this.$parent.$parent,
            service: new FormPerguntaService(this.$http, this.$router),
        }
    },
    created() {
        this.$on("copiar-pergunta", this.copiarPergunta);
        this.$on("excluir-pergunta", this.excluirPergunta);
        this.$on("update-pergunta", this.updatePergunta);
    },
    methods: {
        setLoading(isLoading) {
            this.$emit("isLoading", isLoading)
        },
        reload() {
            this.$emit("reload", true);
        },
        addCampo() {
            this.formPerguntaList.push({
                datahoradel: null,
                obrigatorio: false,
                item_tipo: 'TEXT',
                descricao: null,
                formRespostaItemList: [{
                    datahorainc: null,
                    datahoraalt: null,
                    id_form_pergunta: null,
                    descricao: null,
                    habilita_foto: 0,
                    situacao: 1,
                    datahoradel: null,
                }],
            });
            this.emitGrupoPergunta();
        },
        copiarPergunta(i) {
            let novaPergunta = JSON.parse(JSON.stringify(this.formPerguntaList[i]));
            novaPergunta.id = null;
            novaPergunta.formRespostaItemList.forEach((formRespostaItem) => {
                formRespostaItem.id = null;
            });
            this.formPerguntaList.push(Object.assign({}, novaPergunta));
            this.emitGrupoPergunta();
        },
        excluirPergunta(i) {
            if(this.isNull(this.formPerguntaList[i].id) || this.formPerguntaList[i].id == 0) {
                this.formPerguntaList.splice(i, 1);
            } else {
                this.formPerguntaList[i].datahoradel = new Date();
            }
            this.$emit('isChanged', true);
            this.$forceUpdate();
        },
        updatePergunta(p, i) {
            this.emitGrupoPergunta(i);
        },
        emitGrupoPergunta(i) {
            setTimeout(() => {
                this.formulario.$emit('update-grupoperguntas', this.formPerguntaList, this.index);
            }, 200);
        },
    },
};
</script>

<style lang="scss" scoped>
.configura-campos {
    width: 100%;
    margin-top: 15px;

    > .novos-campos {
        margin-bottom: 20px;
        position: relative;

        .campo.campo-not-expanded + .campo.campo-not-expanded {
            border-top: none;
        }
    }

    > .add-campos {
        @include exclude-button();
        position: relative;
        border-radius: 10px;
        padding: 10px 80px;
        text-align: center;
        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        margin-left: calc(50% - 177px);

        > p {
            display: flex;
            align-items: center;
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: $darker-gray-color;

            > svg {
                margin-right: 10px;
                fill: $light-gray-color;
            }
        }
    }
}
</style>
